var React = require('react');

function Patient (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"Bounding_Boxes","key":0},[React.createElement("g",{"id":"ui_x5F_spec_x5F_header_copy_3","display":"none","key":0}),React.createElement("path",{"fill":"none","d":"M0,0h24v24H0V0z","key":1})]),React.createElement("g",{"id":"Rounded_1_","key":1},[React.createElement("g",{"id":"ui_x5F_spec_x5F_header_copy_6","display":"none","key":0}),React.createElement("path",{"d":"M17,7h-3c-0.55,0-1,0.45-1,1c0,0.55,0.45,1,1,1h3c1.65,0,3,1.35,3,3c0,1.65-1.35,3-3,3h-3c-0.55,0-1,0.45-1,1\n\t\tc0,0.55,0.45,1,1,1h3c2.76,0,5-2.24,5-5S19.76,7,17,7z M8,12c0,0.55,0.45,1,1,1h6c0.55,0,1-0.45,1-1c0-0.55-0.45-1-1-1H9\n\t\tC8.45,11,8,11.45,8,12z M10,15H7c-1.65,0-3-1.35-3-3c0-1.65,1.35-3,3-3h3c0.55,0,1-0.45,1-1c0-0.55-0.45-1-1-1H7\n\t\tc-2.76,0-5,2.24-5,5s2.24,5,5,5h3c0.55,0,1-0.45,1-1C11,15.45,10.55,15,10,15z","key":1})])]);
}

Patient.defaultProps = {"version":"1.1","x":"0px","y":"0px","width":"24px","height":"24px","viewBox":"0 0 24 24","enableBackground":"new 0 0 24 24","xmlSpace":"preserve"};

module.exports = Patient;

Patient.default = Patient;



//////////////////
// WEBPACK FOOTER
// /home/winc/bitbucket/iol2/sandbox-manager-v3/node_modules/svg-react-loader/lib/loader.js?name=Patient!./src/assets/icons/round-link.svg
// module id = 703
// module chunks = 1